import React from "react";
import { Box, Stack, Typography, DialogContent } from "@mui/material";
import {
  CalendarMonth,
  Update,
  NoteAlt,
  Person,
  LocationOn,
  History,
} from "@mui/icons-material";

import { useTimezoneFormatter } from "../../../../hooks/useTimezoneFormatter";
import { IGuestVisitHistory } from "../../../../redux/student/student.types";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { formatText } from "../../../../helpers";
import { StatusRenderer } from "../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";

export const GuestHistoryPopoverContent: React.FC<{
  data: IGuestVisitHistory[];
  open: boolean;
  onClose: () => void;
}> = ({ data, open, onClose }) => {
  const { ftDateTime } = useTimezoneFormatter();

  return (
    <Dialog open={open} onClose={onClose} title="Guest History" size="sm">
      <DialogContent sx={{ pt: 1 }}>
        <Stack spacing={2}>
          {data.map((item, index) => {
            const isLast = index === data.length - 1;

            return (
              <Box key={index} sx={{ display: "flex", position: "relative" }}>
                {/* Timeline */}
                <Box
                  sx={{
                    position: "relative",
                    minWidth: 40,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {!isLast && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 30,
                        width: 2,
                        height: "100%",
                        backgroundColor: "#cfcfcf",
                      }}
                    />
                  )}

                  <Box
                    sx={{
                      background: "#fff",
                      borderRadius: "50%",
                      border: "2px solid #dcdcdc",
                      width: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    <History sx={{ fontSize: 18, color: "#2e7d32" }} />
                  </Box>
                </Box>

                {/* Content */}
                <Box sx={{ flex: 1, ml: 1 }}>
                  <Stack spacing={0.5}>
                    {/* Line 1 */}
                    <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                      <Person sx={{ fontSize: 14, mr: 0.5 }} />
                      {item.modified_by_name ||
                        item.created_by_name ||
                        "System"}{" "}
                      updated status to{" "}
                      <StatusRenderer status={item.status || ""} />
                    </Typography>

                    {/* Line 2 */}
                    <Typography sx={{ fontSize: "12px", color: "#555" }}>
                      <LocationOn sx={{ fontSize: 14, mr: 0.5 }} />
                      {formatText(item.venue_name || "--")}
                    </Typography>

                    {/* Line 3 */}
                    {item.booking_date && (
                      <Typography sx={{ fontSize: "12px", color: "#555" }}>
                        <CalendarMonth sx={{ fontSize: 14, mr: 0.5 }} />
                        Booking: {ftDateTime(item.booking_date)}
                      </Typography>
                    )}

                    {/* Line 4 */}
                    {item.remarks && (
                      <Typography sx={{ fontSize: "12px", color: "#444" }}>
                        <NoteAlt sx={{ fontSize: 14, mr: 0.5 }} />
                        {item.remarks}
                      </Typography>
                    )}

                    {/* Timestamp */}
                    <Typography
                      sx={{
                        fontSize: "11px",
                        color: "#888",
                      }}
                    >
                      {ftDateTime(item.create_ts || "")}
                    </Typography>
                  </Stack>
                </Box>
              </Box>
            );
          })}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
